<template>
  <div v-if="isShow.isKVShow" class="pg-kv" :class="{ topToBottom: bgState }">
    <div class="yindaoLayer" v-show="!bgState">
      <div class="yindaotxt" @click="allTxtClickFlag&&showAllTxt()">
        <div
          class="txt txt0"
          v-show="txt0state"
          :class="{ jianbian: txt0state }"
        ></div>
        <div
          class="txt txt1"
          v-show="txt1state"
          :class="{ jianbian: txt1state }"
        ></div>
        <div
          class="txt txt2"
          v-show="txt2state"
          :class="{ jianbian: txt2state }"
        ></div>
        <div
          class="txt txt3"
          v-show="txt3state"
          :class="{ jianbian: txt3state }"
        ></div>
        <div
          class="txt txt4"
          v-show="txt4state"
          :class="{ jianbian: txt4state }"
        ></div>
        <div
          class="txt txt5"
          v-show="txt5state"
          :class="{ jianbian: txt5state }"
        ></div>
        <div
          class="txt txt6"
          v-show="txt6state"
          :class="{ jianbian: txt6state }"
        ></div>
        <div
          class="txt txt7"
          v-show="txt7state"
          :class="{ jianbian: txt7state }"
        ></div>
        <div
          class="txt txt8"
          v-show="txt8state"
          :class="{ jianbian: txt8state }"
        ></div>
        <div
          class="txt txt9"
          v-show="txt9state"
          :class="{ jianbian: txt9state }"
        ></div>
        <div
          class="txt txt10"
          v-show="txt10state"
          :class="{ jianbian: txt10state }"
        ></div>
        <div
          class="txt txt11"
          v-show="txt11state"
          :class="{ jianbian: txt11state }"
        ></div>
        <div
          class="txt txt12"
          v-show="txt12state"
          :class="{ jianbian: txt12state }"
        ></div>
      </div>
    </div>

    <!--流星-->
    <div class="liuxing">
      <div class="lx lx1"></div>
      <div class="lx" v-show="lx2State" :class="{ lx2: lx2State }"></div>
      <div class="lx" v-show="lx3State" :class="{ lx3: lx3State }"></div>
      <div class="lx" v-show="lx4State" :class="{ lx4: lx4State }"></div>
      <div class="lx" v-show="lx5State" :class="{ lx5: lx5State }"></div>
      <div class="lx" v-show="lx6State" :class="{ lx6: lx6State }"></div>
    </div>

    <!--星球-->
    <div class="p1-a-1"></div>
    <div class="p1-a-2"></div>

    <div class="pgkv">
      <div class="p1-2" v-show="yhgState">
        <div class="p1-2Inner">
          <div class="p1-2-0"></div>
          <div class="p1-2-1"></div>
          <div class="p1-2-2"></div>

          <!--门-->
          <div class="men">
            <div class="menInner">
              <div class="men-left" :class="{ openleft: opendoor }"></div>
              <div class="men-right" :class="{ openright: opendoor }"></div>
              <div class="damen"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="title" :class="{ titleselect: titleSelectState }">
        <div class="titleInner">
          <svg
            id="layer1"
            v-show="svgState"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 623.78 310.64"
          >
            <polygon
              id="a0"
              :class="{ wwa0: a0State }"
              v-show="a0State"
              points="45.42 20.48 45.42 34.07 53.42 33.14 53.42 20.48 45.42 20.48"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <rect
              id="a1"
              :class="{ wwa1: a1State }"
              v-show="a1State"
              x="42.63"
              y="37.79"
              width="8"
              height="13.02"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="a2"
              :class="{ wwa2: a2State }"
              v-show="a2State"
              points="41.14 54.72 35 77.6 42.63 77.6 49.42 54.72 41.14 54.72"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="a3"
              :class="{ wwa3: a3State }"
              v-show="a3State"
              points="50.63 59.55 57.51 20.48 80.39 18.62 74.44 57.51 69.79 57.88 69.05 54.72 73.33 25.14 62.91 25.14 58.07 54.72 55.09 59.55 50.63 59.55"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="a4"
              :class="{ wwa4: a4State }"
              v-show="a4State"
              points="64.77 29.79 60.49 55.83 48.21 75.93 56.49 75.93 62.35 64.58 64.77 74.62 72.95 74.81 66.26 54.72 69.79 29.79 64.77 29.79"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="a5"
              :class="{ wwa5: a5State }"
              v-show="a5State"
              points="83.19 20.48 76.49 59.55 81.7 59.55 88.39 20.48 83.19 20.48"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="a6"
              :class="{ wwa6: a6State }"
              v-show="a6State"
              points="91.37 16.2 83.93 67.18 77.79 73.69 87.65 73.69 91.37 69.97 98.81 16.2 91.37 16.2"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b0"
              :class="{ wwb0: b0State }"
              v-show="b0State"
              points="106.63 16.2 106.63 28.48 113.88 28.48 114.81 16.2 106.63 16.2"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b1"
              :class="{ wwb1: b1State }"
              v-show="b1State"
              points="104.39 32.76 104.39 46.16 111.65 44.95 111.65 32.76 104.39 32.76"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b2"
              :class="{ wwb2: b2State }"
              v-show="b2State"
              points="103.09 49.88 96.58 72.2 104.39 72.2 110.72 49.88 103.09 49.88"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b3"
              :class="{ wwb3: b3State }"
              v-show="b3State"
              points="112.58 54.72 118.91 14.16 141.6 13.04 135.47 51.93 132.3 52.86 130.07 48.58 134.35 19.55 124.12 20.48 118.72 49.88 116.49 54.72 112.58 54.72"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b4"
              :class="{ wwb4: b4State }"
              v-show="b4State"
              points="125.79 24.95 120.95 50.81 109.42 70.53 117.6 70.53 122.81 59.55 125.79 70.53 133.79 69.04 127.09 49.88 131 24.95 125.79 24.95"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b5"
              :class="{ wwb5: b5State }"
              v-show="b5State"
              points="144.21 16.2 137.88 54.72 142.72 54.72 149.23 16.2 144.21 16.2"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="b6"
              :class="{ wwb6: b6State }"
              v-show="b6State"
              points="152.21 11.37 144.95 61.04 139 69.04 149.23 67.93 152.21 63.46 159.65 11.37 152.21 11.37"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="c0"
              :class="{ wwc0: c0State }"
              v-show="c0State"
              points="165.42 13.04 164.3 21.04 167.84 21.04 159.65 67.37 171.37 66.07 180.3 8.02 165.42 13.04"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="c1"
              :class="{ wwc1: c1State }"
              v-show="c1State"
              points="185.88 8.02 181.23 27.18 189.23 27.18 191.65 19.74 207.84 19.37 207.84 23.27 216.02 23.27 219.19 11.37 193.7 13.04 194.63 8.02 185.88 8.02"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="c2"
              :class="{ wwc2: c2State }"
              v-show="c2State"
              points="181.23 31.46 174.53 59.93 181.23 59.93 188.49 30.53 181.23 31.46"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="c3"
              :class="{ wwc3: c3State }"
              v-show="c3State"
              points="193.88 24.95 188.49 58.44 182.72 65.88 194.81 64.76 198.35 59.93 204.3 23.65 193.88 24.95"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="c4"
              :class="{ wwc4: c4State }"
              v-show="c4State"
              points="206.72 29.23 205.23 57.51 212.49 57.51 214.35 29.23 206.72 29.23"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="d0"
              :class="{ wwd0: d0State }"
              v-show="d0State"
              points="235.56 3.37 230.16 11 222.16 59.93 245.23 59.93 253.6 8.02 245.98 8.02 247.46 3.37 235.56 3.37"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="d1"
              :class="{ wwd1: d1State }"
              v-show="d1State"
              points="237.05 16.2 235.56 30.53 239.28 30.53 241.88 16.2 237.05 16.2"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="d2"
              :class="{ wwd2: d2State }"
              v-show="d2State"
              points="233.7 37.69 230.91 53.79 236.3 53.79 238.72 37.69 233.7 37.69"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="d3"
              :class="{ wwd3: d3State }"
              v-show="d3State"
              points="260.12 1.69 255.09 16.2 253.6 22.53 262.35 22.53 264.95 16.2 270.35 16.2 265.88 39.46 263.46 28.11 253.6 28.11 255.46 44.76 264.95 43.37 265.32 50.44 258.81 57.51 270.35 56.76 273.7 53.79 280.58 8.02 268.3 8.95 272.02 0.58 260.12 1.69"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="e0"
              :class="{ wwe0: e0State }"
              v-show="e0State"
              points="23.28 108.48 21.98 115.93 11.74 117.23 8.58 151.83 5.79 151.83 4.12 165.79 6.91 165.79 0.58 207.65 12.86 207.65 17.88 164.11 32.02 163.55 28.86 196.67 21.23 206.72 37.6 205.6 40.21 201.88 44.67 161.32 46.91 161.32 49.42 148.67 46.72 148.3 50.44 114.44 37.23 114.44 38.35 107.55 23.28 108.48"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="e1"
              :class="{ wwe1: e1State }"
              v-show="e1State"
              points="22.91 127.46 20.12 150.72 35 150.72 36.49 125.79 22.91 127.46"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="e2"
              :class="{ wwe2: e2State }"
              v-show="e2State"
              points="25.51 132.48 23.65 147.18 32.02 147.18 33.7 131.37 25.51 132.48"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="e3"
              :class="{ wwe3: e3State }"
              v-show="e3State"
              points="20.12 168.02 18.26 188.67 27.19 188.67 28.3 168.02 20.12 168.02"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="e4"
              :class="{ wwe4: e4State }"
              v-show="e4State"
              points="67.19 104.39 69.42 108.86 69.42 116.11 52.67 116.11 51.37 129.88 100.67 126.72 101.79 113.32 88.3 113.88 88.3 102.9 67.19 104.39"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="e5"
              :class="{ wwe5: e5State }"
              v-show="e5State"
              points="43.19 204.48 55.28 136.95 94.53 133.79 88.3 186.07 90.63 185.69 95.84 180.86 93.42 201.13 70.91 202.81 76.58 149.23 67.93 150.72 58.63 203.37 43.19 204.48"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="f0"
              :class="{ wwf0: f0State }"
              v-show="f0State"
              points="129.32 101.97 127.65 114.62 152.02 112.39 139.84 135.28 117.42 136.39 115.93 149.79 132.86 149.79 107.37 199.09 130.63 199.09 156.49 145.52 162.81 145.52 178.63 192.95 202.07 191.83 186.44 145.02 203.74 143.09 205.05 128.95 164.86 132.48 175.47 111.09 199.47 109.04 202.07 96.2 129.32 101.97"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="g0"
              :class="{ wwg0: g0State }"
              v-show="g0State"
              points="222.72 91.18 225.32 96.2 214.91 120.39 230.35 119.28 234.81 111.09 236.49 111.09 229.98 130.25 213.23 131.18 212.3 143.83 224.4 143.83 208.58 190.72 228.67 190.72 236.49 166.53 241.14 187.18 259.37 187.55 252.49 147.65 244.67 147.65 246.16 140.95 263.65 139.74 264.95 126.72 249.88 127.83 256.95 108.48 264.95 108.48 266.44 95.46 241.32 97.51 243 90.07 222.72 91.18"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="g1"
              :class="{ wwg1: g1State }"
              v-show="g1State"
              points="269.98 92.86 272.95 97.69 263.46 186.62 301.42 183.28 311.28 89.14 269.98 92.86"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="g2"
              :class="{ wwg2: g2State }"
              v-show="g2State"
              points="288.77 102.34 281.51 171.37 287.37 171.37 294.53 102.34 288.77 102.34"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="h0"
              :class="{ wwh0: h0State }"
              v-show="h0State"
              points="325.79 85.04 329.51 102.34 345.7 102.34 342.16 83.74 325.79 85.04"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="h1"
              :class="{ wwh1: h1State }"
              v-show="h1State"
              points="320.02 109.04 318.16 122.07 323.74 122.07 318.16 181.41 342.91 171.37 344.21 158.16 338.44 160.02 344.21 107.93 320.02 109.04"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="h2"
              :class="{ wwh2: h2State }"
              v-show="h2State"
              points="353.7 83.74 355.56 86.9 350.53 138.81 405.98 134.34 412.86 77.97 353.7 83.74"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="h3"
              :class="{ wwh3: h3State }"
              v-show="h3State"
              points="373.6 93.04 370.25 124.48 390.16 123 392.95 93.04 373.6 93.04"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="h4"
              :class="{ wwh4: h4State }"
              v-show="h4State"
              points="356.67 143.46 342.53 179 359.28 179 373.42 142.34 356.67 143.46"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="h5"
              :class="{ wwh5: h5State }"
              v-show="h5State"
              points="382.72 142.34 388.3 175.83 404.49 174.34 398.72 140.48 382.72 142.34"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="i0"
              :class="{ wwi0: i0State }"
              v-show="i0State"
              points="430.91 73.14 432.95 77.23 424.21 97.32 441.32 96.02 446.53 88.2 449.7 95.65 465.51 94.16 461.98 85.23 469.98 85.23 472.39 76.11 451.19 76.3 453.23 73.14 430.91 73.14"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="i1"
              :class="{ wwi1: i1State }"
              v-show="i1State"
              points="476.3 69.42 478.91 74.81 470.16 93.04 488.21 92.11 491.93 83.55 495.09 92.11 510.91 90.62 508.3 81.23 518.16 81.23 520.21 71.65 497.14 73.14 498.63 68.3 476.3 69.42"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="i2"
              :class="{ wwi2: i2State }"
              v-show="i2State"
              points="429.05 102.34 429.05 112.95 457.88 110.34 457.88 116.11 421.98 118.53 420.3 129.32 477.98 123.74 477.98 129.32 421.79 134.34 420.3 145.02 476.12 140.48 474.63 154.44 465.32 168.95 487.84 167.46 495.19 160.02 497.51 138.81 510.72 138.81 512.02 125.97 499.56 127.28 499.74 121.88 514.63 121.14 516.12 110.34 479.46 113.88 479.65 108.39 510.16 105.88 511.09 95.28 480.95 98.81 481.32 95.28 460.12 97.32 459.74 100.3 429.05 102.34"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="i3"
              :class="{ wwi3: i3State }"
              v-show="i3State"
              points="428.3 149.6 436.86 163.55 460.3 162.25 451.74 147.18 428.3 149.6"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="j0"
              :class="{ wwj0: j0State }"
              v-show="j0State"
              points="545.32 63.83 546.81 68.3 531.74 99.37 531.74 108.48 537.88 108.48 530.25 125.04 527.65 140.67 558.53 138.62 560.02 125.79 545.51 126.34 563 95.28 551.28 94.16 567.65 61.79 545.32 63.83"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="j1"
              :class="{ wwj1: j1State }"
              v-show="j1State"
              points="526.53 148.86 524.49 161.88 556.49 157.04 558.72 143.83 526.53 148.86"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="j2"
              :class="{ wwj2: j2State }"
              v-show="j2State"
              points="571.74 63.83 571.74 77.04 576.39 77.04 558.72 161.88 573.04 160.21 582.53 121.69 587.93 133.79 575.65 159.65 593.14 158.53 596.3 152.02 599.28 157.79 617.51 156.86 606.16 130.44 623.28 99 623.28 88.58 616.21 89.69 623.28 72.2 623.28 60.67 571.74 63.83"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polygon
              id="j3"
              :class="{ wwj2: j2State }"
              v-show="j2State"
              points="592.77 75.93 585.14 107.18 592.77 106.25 603.93 74.81 592.77 75.93"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
            <polyline
              id="k0"
              :class="{ wwk0: k0State }"
              v-show="k0State"
              points="3.93 309.97 11.19 277.79 18.81 277.79 11.37 309.97 16.21 308.86 21.42 284.67 27 284.3 23.46 308.86 25.51 308.3 59.37 305.13 71.65 286.53 73.88 270.53 73.88 286.53 79.47 303.46 112.77 301.41 119.28 280.95 121.14 277.04 127.47 267.18 133.42 270.9 138.25 265.88 134.91 289.51 133.23 300.67 170.44 294.53 175.65 263.27 193.32 262.34 177.88 273.88 193.32 272.2 179.74 283.93 189.98 284.48 188.49 293.23 227.19 274.44 248.77 272.58 284.3 256.95 304.77 254.72 299.93 262.34 285.79 264.76 281.7 272.39 304.77 268.86 283.37 277.6 301.42 277.04 299.56 284.48 338.81 249.32 342.53 252.3 334.16 281.88 339.74 277.6 345.32 251.18 353.88 250.81 353.88 280.58"
              style="fill: none; stroke: #fff; stroke-miterlimit: 10"
            />
          </svg>
        </div>
      </div>
      <!--星空闪闪-->
      <div class="xingkong" v-show="xkState">
        <div class="xk xk1"></div>
        <div class="xk xk2"></div>
        <div class="xk xk3"></div>
        <div class="xk xk4"></div>
        <div class="xk xk5"></div>
        <div class="xk xk6"></div>
        <div class="xk xk7"></div>
        <div class="xk xk8"></div>
        <div class="xk xk9"></div>
        <div class="xk xk10"></div>
      </div>
      <!--太空服人-->
      <div class="taikongren">
        <div class="tkrInner" :class="{ tkryundong: taikongrenState }"></div>
      </div>

      <!--进入航天馆，开始答题-->
      <div
        class="enterBtn"
        @click="enterdoor"
        v-show="btnPlayState"
        :class="{enterActive: btnPlayState2 }"
      >
        <div class="eBtnInner" v-show="!btnPlayState2"></div>
      </div>
    </div>
  </div>
</template>

<script>
//
import { TweenMax, TimelineMax } from "gsap";
export default {
  name: "PageKV",
  props: {
    isShow: Object,
  },
  data() {
    return {
      txt0state: false,
      txt1state: false,
      txt2state: false,
      txt3state: false,
      txt4state: false,
      txt5state: false,
      txt6state: false,
      txt7state: false,
      txt8state: false,
      txt9state: false,
      txt10state: false,
      txt11state: false,
      txt12state: false,
      txt0timeOutstate: null,
      txt1timeOutstate: null,
      txt2timeOutstate: null,
      txt3timeOutstate: null,
      txt4timeOutstate: null,
      txt5timeOutstate: null,
      txt6timeOutstate: null,
      txt7timeOutstate: null,
      txt8timeOutstate: null,
      txt9timeOutstate: null,
      txt10timeOutstate: null,
      txt11timeOutstate: null,
      txt12timeOutstate: null,
      gocityTimeOutstate: null,
      bgState: false,
      yhgState: false,
      a0State: false,
      a1State: false,
      a2State: false,
      a3State: false,
      a4State: false,
      a5State: false,
      a6State: false,
      b0State: false,
      b1State: false,
      b2State: false,
      b3State: false,
      b4State: false,
      b5State: false,
      b6State: false,
      c0State: false,
      c1State: false,
      c2State: false,
      c3State: false,
      c4State: false,
      d0State: false,
      d1State: false,
      d2State: false,
      d3State: false,
      e0State: false,
      e1State: false,
      e2State: false,
      e3State: false,
      e4State: false,
      e5State: false,
      f0State: false,
      g0State: false,
      g1State: false,
      g2State: false,
      h0State: false,
      h1State: false,
      h2State: false,
      h3State: false,
      h4State: false,
      h5State: false,
      i0State: false,
      i1State: false,
      i2State: false,
      i3State: false,
      j0State: false,
      j1State: false,
      j2State: false,
      j3State: false,
      k0State: false,
      svgState: true,
      titleSelectState: false,
      taikongrenState: true,
      btnPlayState: false,
      btnPlayState2: false,
      lx2State: false,
      lx3State: false,
      lx4State: false,
      lx5State: false,
      lx6State: false,
      xkState: false,
      opendoor: false,
      isAllTxtClickState: false,
      allTxtClickFlag:true,
    };
  },
  components: {},
  methods: {
    showNext() {
      setTimeout(() => {
        let data = {
          para: "isPOShow",
        };
        this.$emit("nextPage", data);
      }, 200);
    },
    showAllTxt() {
      this.allTxtClickFlag=false
      this.isAllTxtClickState = true;

      this.txt0state = true;
      this.txt1state = true;
      this.txt2state = true;
      this.txt3state = true;
      this.txt4state = true;
      this.txt5state = true;
      this.txt6state = true;
      this.txt7state = true;
      this.txt8state = true;
      this.txt9state = true;
      this.txt10state = true;
      this.txt11state = true;
      this.txt12state = true;

      clearTimeout(this.txt0timeOutstate)
      clearTimeout(this.txt1timeOutstate)
      clearTimeout(this.txt2timeOutstate)
      clearTimeout(this.txt3timeOutstate)
      clearTimeout(this.txt4timeOutstate)
      clearTimeout(this.txt5timeOutstate)
      clearTimeout(this.txt6timeOutstate)
      clearTimeout(this.txt7timeOutstate)
      clearTimeout(this.txt8timeOutstate)
      clearTimeout(this.txt9timeOutstate)
      clearTimeout(this.txt10timeOutstate)
      clearTimeout(this.txt11timeOutstate)
      clearTimeout(this.txt12timeOutstate)
      clearTimeout(this.gocityTimeOutstate)

      setTimeout(()=>{
        this.goCity();
      },1000)
    },
    enterdoor() {
      let _this = this;
      //太空人继续走入
      this.taikongrenState = true;
      this.opendoor = true;
      this.btnPlayState = false;
      TweenMax.to(".taikongren", 1.5, {
        left: "50vw",
        transform: "scale(0.8)",
        onComplete: function () {
          _this.taikongrenState = false;
          _this.showNext();
        },
      });
    },
    async fetchData() {
      //
    },
    liuxing() {
      setTimeout(() => {
        this.lx2State = true;
      }, 6000);
      setTimeout(() => {
        this.lx3State = true;
      }, 2500);
      setTimeout(() => {
        this.lx4State = true;
      }, 8000);
      setTimeout(() => {
        this.lx5State = true;
      }, 4000);
      setTimeout(() => {
        this.lx6State = true;
      }, 7000);
    },
    yindao() {
      let timer = 600;
      this.txt0timeOutstate=setTimeout(() => {
        this.txt0state = true;
      }, timer);
      this.txt1timeOutstate=setTimeout(() => {
        this.txt1state = true;
      }, timer * 2);
      this.txt2timeOutstate=setTimeout(() => {
        this.txt2state = true;
      }, timer * 3);
      this.txt3timeOutstate=setTimeout(() => {
        this.txt3state = true;
      }, timer * 4);
      this.txt4timeOutstate=setTimeout(() => {
        this.txt4state = true;
      }, timer * 5);
      this.txt5timeOutstate=setTimeout(() => {
        this.txt5state = true;
      }, timer * 6);
      this.txt6timeOutstate=setTimeout(() => {
        this.txt6state = true;
      }, timer * 7);
      this.txt7timeOutstate=setTimeout(() => {
        this.txt7state = true;
      }, timer * 8);
      this.txt8timeOutstate=setTimeout(() => {
        this.txt8state = true;
      }, timer * 9);
      this.txt9timeOutstate=setTimeout(() => {
        this.txt9state = true;
      }, timer * 10);
      this.txt10timeOutstate=setTimeout(() => {
        this.txt10state = true;
      }, timer * 11);
      this.txt11timeOutstate=setTimeout(() => {
        this.txt11state = true;
      }, timer * 12);
      this.txt12timeOutstate=setTimeout(() => {
        this.txt12state = true;
      }, timer * 13);

      this.gocityTimeOutstate=setTimeout(() => {
          this.goCity();
      }, timer * 14);
    },
    goCity() {
      let timer = 600;
      setTimeout(() => {
        //gogogo
        this.gogogo();
      }, timer);
      setTimeout(() => {
        //gogogo
        this.gogogo2();
      }, timer + 500);
      setTimeout(() => {
        //gogogo
        this.gogogo3();
      }, timer + 1500);
    },
    gogogo() {
      this.bgState = true;
      //星球
      TweenMax.to(".p1-a-1", 1, {
        left: "-80px",
        marginLeft: "0%",
        transform: "scale(0.8)",
      });
      TweenMax.to(".p1-a-2", 1, { right: "-200px", transform: "scale(0.8)" });
    },
    gogogo2() {
      //建筑物
      this.yhgState = true;
      TweenMax.to(".p1-2", 1.2, { bottom: "0px" });
      TweenMax.to(".liuxing", 3, { opacity: "0" });
    },
    gogogo3() {
      let _this = this;

      this.a0State = true;
      this.a1State = true;
      this.a2State = true;
      this.a3State = true;
      this.a4State = true;
      this.a5State = true;
      this.a6State = true;
      this.b0State = true;
      this.b1State = true;
      this.b2State = true;
      this.b3State = true;
      this.b4State = true;
      this.b5State = true;
      this.b6State = true;
      this.c0State = true;
      this.c1State = true;
      this.c2State = true;
      this.c3State = true;
      this.c4State = true;
      this.d0State = true;
      this.d1State = true;
      this.d2State = true;
      this.d3State = true;
      this.e0State = true;
      this.e1State = true;
      this.e2State = true;
      this.e3State = true;
      this.e4State = true;
      this.e5State = true;
      this.f0State = true;
      this.g0State = true;
      this.g1State = true;
      this.g2State = true;
      this.h0State = true;
      this.h1State = true;
      this.h2State = true;
      this.h3State = true;
      this.h4State = true;
      this.h5State = true;
      this.i0State = true;
      this.i1State = true;
      this.i2State = true;
      this.i3State = true;
      this.j0State = true;
      this.j1State = true;
      this.j2State = true;
      this.j3State = true;
      this.k0State = true;

      //大标题
      setTimeout(() => {
        this.svgState = false;
        this.titleSelectState = true;
      }, 1000);

      //太空人走入
      TweenMax.fromTo(".taikongren", 3, {
        left: "-8vw"
      },{
        left: "30vw",
        onComplete: function () {
          _this.taikongrenState = false;
        },
      });

      //进入航天馆，开始答题
      setTimeout(() => {
        this.xkState = true;
      }, 2000);
      setTimeout(() => {
        this.btnPlay();
      }, 1200);
    },
    btnPlay() {
      this.btnPlayState = true;

      var tl = new TimelineMax();
      tl.fromTo(
        ".eBtnInner",
        1,
        { transform: "scale(0,0)" },
        { transform: "scale(1,0.01)" }
      );
      tl.to(".eBtnInner", 0.5, { transform: "scale(1,1)" });

      setTimeout(() => {
        this.btnPlayState2 = true;
      }, 1500);
    },
    pageKVReset(){
      this.txt0state = false
      this.txt1state = false
      this.txt2state = false
      this.txt3state = false
      this.txt4state = false
      this.txt5state = false
      this.txt6state = false
      this.txt7state = false
      this.txt8state = false
      this.txt9state = false
      this.txt10state = false
      this.txt11state = false
      this.txt12state = false
      this.txt0timeOutstate = null
      this.txt1timeOutstate = null
      this.txt2timeOutstate = null
      this.txt3timeOutstate = null
      this.txt4timeOutstate = null
      this.txt5timeOutstate = null
      this.txt6timeOutstate = null
      this.txt7timeOutstate = null
      this.txt8timeOutstate = null
      this.txt9timeOutstate = null
      this.txt10timeOutstate = null
      this.txt11timeOutstate = null
      this.txt12timeOutstate = null
      this.gocityTimeOutstate = null
      this.bgState = false
      this.yhgState = false
      this.a0State = false
      this.a1State = false
      this.a2State = false 
      this.a3State = false 
      this.a4State = false 
      this.a5State = false 
      this.a6State = false 
      this.b0State = false 
      this.b1State = false 
      this.b2State = false 
      this.b3State = false 
      this.b4State = false 
      this.b5State = false 
      this.b6State = false 
      this.c0State = false 
      this.c1State = false 
      this.c2State = false 
      this.c3State = false 
      this.c4State = false 
      this.d0State = false 
      this.d1State = false 
      this.d2State = false 
      this.d3State = false 
      this.e0State = false 
      this.e1State = false 
      this.e2State = false 
      this.e3State = false 
      this.e4State = false 
      this.e5State = false 
      this.f0State = false 
      this.g0State = false 
      this.g1State = false 
      this.g2State = false 
      this.h0State = false 
      this.h1State = false 
      this.h2State = false 
      this.h3State = false 
      this.h4State = false 
      this.h5State = false 
      this.i0State = false 
      this.i1State = false 
      this.i2State = false 
      this.i3State = false 
      this.j0State = false 
      this.j1State = false 
      this.j2State = false 
      this.j3State = false 
      this.k0State = false 
      this.svgState = true 
      this.titleSelectState = false 
      this.taikongrenState = true 
      this.btnPlayState = false 
      this.btnPlayState2 = false 
      this.lx2State = false 
      this.lx3State = false 
      this.lx4State = false 
      this.lx5State = false 
      this.lx6State = false 
      this.xkState = false 
      this.opendoor = false 
      this.isAllTxtClickState = false 
      this.allTxtClickFlag=true
    },
  },
  created() {
    // this.fetchData();
  },
  watch: {
    "isShow.isKVShow": function () {
      //重置
      this.pageKVReset()

      this.yindao();
      this.liuxing();
    },
  },
};
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg-kv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-image: url(./img/bg.jpg);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 0 0;
}

.yindaotxt {
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  margin-left: -(33.4375rem/4) /* 535/16 */;
  z-index: 5;
  padding-top: 10vh;

  .txt {
    width: (33.4375rem/2) /* 535/16 */;
  }
  .txt0 {
    height: (3.125rem/2) /* 50/16 */;
    .bg("./img/p1-t0.png");
  }
  .txt1 {
    height: (4.375rem/2) /* 70/16 */;
    .bg("./img/p1-t1.png");
  }
  .txt2 {
    height: (4.0625rem/2) /* 65/16 */;
    .bg("./img/p1-t2.png");
  }
  .txt3 {
    height: (6.125rem/2) /* 98/16 */;
    .bg("./img/p1-t3.png");
  }
  .txt4 {
    height: (6rem/2) /* 96/16 */;
    .bg("./img/p1-t4.png");
  }
  .txt5 {
    height: (4.4375rem/2) /* 71/16 */;
    .bg("./img/p1-t5.png");
  }
  .txt6 {
    height: (4.125rem/2) /* 66/16 */;
    .bg("./img/p1-t6.png");
  }
  .txt7 {
    height: (4.125rem/2) /* 66/16 */;
    .bg("./img/p1-t7.png");
  }
  .txt8 {
    height: (6rem/2) /* 96/16 */;
    .bg("./img/p1-t8.png");
  }
  .txt9 {
    height: (6.375rem/2) /* 102/16 */;
    .bg("./img/p1-t9.png");
  }
  .txt10 {
    height: (3.875rem/2) /* 62/16 */;
    .bg("./img/p1-t10.png");
  }
  .txt11 {
    height: (4.3125rem/2) /* 69/16 */;
    .bg("./img/p1-t11.png");
  }
  .txt12 {
    height: (3.375rem/2) /* 54/16 */;
    .bg("./img/p1-t12.png");
  }
}

//星球
.p1-a-1 {
  width: (45.3125rem/2) /* 725/16 */;
  height: (48.4375rem/2) /* 775/16 */;
  .bg("./img/p1-a-1.png");
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -(45.3125rem/4) /* 725/16 */;
}

.p1-a-2 {
  width: (24.0625rem/2) /* 385/16 */;
  height: (24rem/2) /* 384/16 */;
  .bg("./img/p1-a-2.png");
  position: absolute;
  top: 50vh;
  right: -(24.0625rem/4) /* 385/16 */;
}

.topToBottom {
  animation: topToBottomAction 1s;
  background-position: 0 bottom;
}

@keyframes topToBottomAction {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 0 bottom;
  }
}

.p1-2 {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  .bg("./img/p1-2.png");
  position: absolute;
  left: 0;
  bottom: -(85.875rem/2) /* 1374/16 */;
}

.p1-2Inner {
  width: 100%;
  height: 100%;
  position: relative;
}

.p1-2-0 {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  .bg("./img/p1-2-0.png");
  position: absolute;
  left: 0;
  bottom: 0;
  animation: shan 1s infinite linear;
}

@keyframes shan {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.p1-2-1 {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  .bg("./img/p1-2-1.png");
  position: absolute;
  left: 0;
  bottom: 0;
  animation: shan2 3s infinite linear;
}

@keyframes shan2 {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 5px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.p1-2-2 {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  .bg("./img/p1-2-2.png");
  position: absolute;
  left: 0;
  bottom: 0;
  animation: shan3 5s infinite linear;
}

@keyframes shan3 {
  0% {
    background-image: url("./img/p1-2-2.png");
    transform: translate(0, 0);
  }
  50% {
    background-image: url("./img/p1-2-3.png");
    transform: translate(0, -15px);
  }
  100% {
    background-image: url("./img/p1-2-2.png");
    transform: translate(0, 0);
  }
}

.men {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  position: absolute;
  left: 0;
  bottom: 0;
}

.damen {
  .bg("./img/p1-4.png");
}

.menInner {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  position: relative;
}

.men-left,
.men-right,
.damen {
  width: 100vw;
  height: (85.875rem/2) /* 1374/16 */;
  position: absolute;
  left: 0;
  top: 0;
}

.men-left {
  .bg("./img/p1-4-0.png");
}

.men-right {
  .bg("./img/p1-4-1.png");
}

.openleft {
  animation: openleftdong 2s linear;
}

@keyframes openleftdong {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-30px, 0);
  }
}

.openright {
  animation: openrightdong 2s linear;
}

@keyframes openrightdong {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 0);
  }
}

.title {
  width: (46.875rem/2) /* 750/16 */;
  height: (23.4375rem/2) /* 375/16 */;
  position: absolute;
  left: 50%;
  margin-left: -(46.875rem/4) /* 750/16 */;
  top: 10vh;
  z-index: 3;
}

.titleselect {
  .bg("./img/p1-1.png");
}

.titleInner {
  width: (39.25rem/2) /* 628/16 */;
  margin: 0 auto;
  padding-top: 21px;
}

@keyframes a0path {
  to {
    stroke-dasharray: 0;
  }
}

.wwa0 {
  stroke-dasharray: 43;
  stroke-dashoffset: 43;
  animation: a0path 1s linear forwards;
}

.wwa1 {
  stroke-dasharray: 43;
  stroke-dashoffset: 43;
  animation: a0path 1s linear forwards;
}

.wwa2 {
  stroke-dasharray: 64;
  stroke-dashoffset: 64;
  animation: a0path 1s linear forwards;
}

.wwa3 {
  stroke-dasharray: 191;
  stroke-dashoffset: 191;
  animation: a0path 1s linear forwards;
}

.wwa4 {
  stroke-dasharray: 141;
  stroke-dashoffset: 141;
  animation: a0path 1s linear forwards;
}

.wwa5 {
  stroke-dasharray: 90;
  stroke-dashoffset: 90;
  animation: a0path 1s linear forwards;
}

.wwa6 {
  stroke-dasharray: 138;
  stroke-dashoffset: 138;
  animation: a0path 1s linear forwards;
}

.wwb0 {
  stroke-dasharray: 40;
  stroke-dashoffset: 40;
  animation: a0path 1s linear forwards;
}

.wwb1 {
  stroke-dasharray: 40;
  stroke-dashoffset: 40;
  animation: a0path 1s linear forwards;
}

.wwb2 {
  stroke-dasharray: 62;
  stroke-dashoffset: 62;
  animation: a0path 1s linear forwards;
}

.wwb3 {
  stroke-dasharray: 190;
  stroke-dashoffset: 190;
  animation: a0path 1s linear forwards;
}

.wwb4 {
  stroke-dasharray: 140;
  stroke-dashoffset: 140;
  animation: a0path 1s linear forwards;
}

.wwb5 {
  stroke-dasharray: 88;
  stroke-dashoffset: 88;
  animation: a0path 1s linear forwards;
}

.wwb6 {
  stroke-dasharray: 136;
  stroke-dashoffset: 136;
  animation: a0path 1s linear forwards;
}

.wwc0 {
  stroke-dasharray: 145;
  stroke-dashoffset: 145;
  animation: a0path 1s linear forwards;
}

.wwc1 {
  stroke-dasharray: 116;
  stroke-dashoffset: 116;
  animation: a0path 1s linear forwards;
}

.wwc2 {
  stroke-dasharray: 73;
  stroke-dashoffset: 73;
  animation: a0path 1s linear forwards;
}

.wwc3 {
  stroke-dasharray: 109;
  stroke-dashoffset: 109;
  animation: a0path 1s linear forwards;
}

.wwc4 {
  stroke-dasharray: 72;
  stroke-dashoffset: 72;
  animation: a0path 1s linear forwards;
}

.wwd0 {
  stroke-dasharray: 159;
  stroke-dashoffset: 159;
  animation: a0path 1s linear forwards;
}

.wwd1 {
  stroke-dasharray: 38;
  stroke-dashoffset: 38;
  animation: a0path 1s linear forwards;
}

.wwd2 {
  stroke-dasharray: 43;
  stroke-dashoffset: 43;
  animation: a0path 1s linear forwards;
}

.wwd3 {
  stroke-dasharray: 227;
  stroke-dashoffset: 227;
  animation: a0path 1s linear forwards;
}

.wwe0 {
  stroke-dasharray: 380;
  stroke-dashoffset: 380;
  animation: a0path 1s linear forwards;
}

.wwe1 {
  stroke-dasharray: 77;
  stroke-dashoffset: 77;
  animation: a0path 1s linear forwards;
}

.wwe2 {
  stroke-dasharray: 59;
  stroke-dashoffset: 59;
  animation: a0path 1s linear forwards;
}

.wwe3 {
  stroke-dasharray: 59;
  stroke-dashoffset: 59;
  animation: a0path 1s linear forwards;
}

.wwe4 {
  stroke-dasharray: 152;
  stroke-dashoffset: 152;
  animation: a0path 1s linear forwards;
}

.wwe5 {
  stroke-dasharray: 345;
  stroke-dashoffset: 345;
  animation: a0path 1s linear forwards;
}

.wwf0 {
  stroke-dasharray: 590;
  stroke-dashoffset: 590;
  animation: a0path 1s linear forwards;
}

.wwg0 {
  stroke-dasharray: 451;
  stroke-dashoffset: 451;
  animation: a0path 1s linear forwards;
}

.wwg1 {
  stroke-dasharray: 270;
  stroke-dashoffset: 270;
  animation: a0path 1s linear forwards;
}

.wwg2 {
  stroke-dasharray: 151;
  stroke-dashoffset: 151;
  animation: a0path 1s linear forwards;
}

.wwh0 {
  stroke-dasharray: 70;
  stroke-dashoffset: 70;
  animation: a0path 1s linear forwards;
}

.wwh1 {
  stroke-dasharray: 201;
  stroke-dashoffset: 201;
  animation: a0path 1s linear forwards;
}

.wwh2 {
  stroke-dasharray: 228;
  stroke-dashoffset: 228;
  animation: a0path 1s linear forwards;
}

.wwh3 {
  stroke-dasharray: 101;
  stroke-dashoffset: 101;
  animation: a0path 1s linear forwards;
}

.wwh4 {
  stroke-dasharray: 111;
  stroke-dashoffset: 111;
  animation: a0path 1s linear forwards;
}

.wwh5 {
  stroke-dasharray: 101;
  stroke-dashoffset: 101;
  animation: a0path 1s linear forwards;
}

.wwi0 {
  stroke-dasharray: 152;
  stroke-dashoffset: 152;
  animation: a0path 1s linear forwards;
}

.wwi1 {
  stroke-dasharray: 159;
  stroke-dashoffset: 159;
  animation: a0path 1s linear forwards;
}

.wwi2 {
  stroke-dasharray: 607;
  stroke-dashoffset: 607;
  animation: a0path 1s linear forwards;
}

.wwi3 {
  stroke-dasharray: 81;
  stroke-dashoffset: 81;
  animation: a0path 1s linear forwards;
}

.wwj0 {
  stroke-dasharray: 253;
  stroke-dashoffset: 253;
  animation: a0path 1s linear forwards;
}

.wwj1 {
  stroke-dasharray: 92;
  stroke-dashoffset: 92;
  animation: a0path 1s linear forwards;
}

.wwj2 {
  stroke-dasharray: 415;
  stroke-dashoffset: 415;
  animation: a0path 1s linear forwards;
}

.wwj3 {
  stroke-dasharray: 85;
  stroke-dashoffset: 85;
  animation: a0path 1s linear forwards;
}

.wwk0 {
  stroke-dasharray: 910;
  stroke-dashoffset: 910;
  animation: a0path 1s linear forwards;
}

.taikongren {
  width: (12.6875rem/2) /* 203/16 */;
  height: (20.1875rem/2) /* 323/16 */;
  position: absolute;
  left: -(12.6875rem/2) /* 203/16 */;
  bottom: (10rem/2) /* 235/16 */;
}

.tkrInner {
  width: (12.6875rem/2) /* 203/16 */;
  height: (20.1875rem/2) /* 323/16 */;
  .bg("./img/p1-r-0.png");
}

.tkryundong {
  animation: tkrAction 1s infinite linear;
}

@keyframes tkrAction {
  0% {
    .bg("./img/p1-r-0.png");
  }
  50% {
    .bg("./img/p1-r-1.png");
  }
  100% {
    .bg("./img/p1-r-0.png");
  }
}

.enterBtn {
  width: (33.4375rem/2)*1.1 /* 535/16 */;
  height: (10.375rem/2)*1.1 /* 166/16 */;
  position: absolute;
  left: 50%;
  margin-left: -(33.4375rem/4)*1.1 /* 535/16 */;
  bottom: 10vh;
  z-index: 12;
}

.enterActive {
  .bg("./img/p1-3.png");
  animation: enterActiveAction 1s infinite linear;
}

@keyframes enterActiveAction {
  0% {
    background-image: url("./img/p1-3.png");
  }
  50% {
    background-image: url("./img/p1-3-0.png");
  }
  100% {
    background-image: url("./img/p1-3.png");
  }
}

.eBtnInner {
  width: 100%;
  height: 100%;
  .bg("./img/p1-3-1.png");
  background-size: 100% auto;
}

.liuxing {
  width: 100vw;
  height: 100vh;
  position: relative;

  .lx {
    opacity: 0;
    position: absolute;
  }

  .lx1 {
    width: (13.8125rem/2) /* 221/16 */;
    height: (9.1875rem/2) /* 147/16 */;
    .bg("./img/p1-liuxing0.png");
    left: (1.875rem/2) /* 30/16 */;
    top: (31.25rem/2) /* 500/16 */;
    animation: lx1dong 5s linear;
  }

  .lx2 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: (3.125rem/2) /* 50/16 */;
    top: -(3.125rem/2) /* 50/16 */;
    animation: lx1dong 4s linear;
  }

  .lx3 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 150px;
    top: 10px;
    animation: lx3dong 5s linear;
  }

  .lx4 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 0;
    top: 400px;
    animation: lx1dong 4s linear;
  }

  .lx5 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: -100px;
    top: -80px;
    animation: lx3dong 3s linear;
  }

  .lx6 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 150px;
    top: 650px;
    animation: lx3dong 2s linear;
  }
}

@keyframes lx1dong {
  0% {
    transform: translate(-100px, 0);
    opacity: 1;
  }
  100% {
    transform: translate(750px, 600px);
    opacity: 1;
  }
}

@keyframes lx2dong {
  0% {
    transform: translate(-100px, 0);
    opacity: 1;
  }
  100% {
    transform: translate(900px, 700px);
    opacity: 1;
  }
}

@keyframes lx3dong {
  0% {
    transform: translate(-100px, 0);
    opacity: 1;
  }
  100% {
    transform: translate(1000px, 800px);
    opacity: 1;
  }
}

.xingkong {
  width: 100vw;
  height: 42.9375rem /* 1374/16 */;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 4;
}

@media only screen and (device-width: 414px) and (device-height: 736px) {
}
</style>
